<!--begin::Title-->
<h3 class="font-bold fs-2qx text-gray-900 mb-4">{{ "TOAST.SYSTEM_ERROR" | translate }}</h3>
<!--end::Title-->

<!--begin::Text-->
<div class="text-muted mb-7">{{ "TOAST.SOMETHING_WENT_WRONG_TRY_AGAIN" | translate }}</div>
<!--end::Text-->

<!--begin::Illustration-->
<div class="mb-3 flex items-center justify-center w-full">
  <img
    src="./assets/media/auth/error500.jpg"
    class="max-w-full max-h-[300px] self-center"
    alt=""
  />
</div>
<!--end::Illustration-->

<!--begin::Link-->
<div class="mb-0">
  <button
    pButton
    [size]="'large'"
    class="!p-2 !px-4 !text-sm"
    (click)="routeToDashboard()"
  >
    {{ "TOAST.RETURN_HOME" | translate }}
  </button>
</div>
<!--end::Link-->
